import morph from "../helpers/morph";

class CartContent extends HTMLElement {
  constructor() {
    super();
    this.requestId = 1;

    this.addEventListener("click", (e) => {
      const removeButton = e.target.closest("[data-remove]");

      if (!removeButton) return;

      const item = e.target.closest("[data-item-key]");

      this._updateQty({ key: item.dataset.itemKey, quantity: 0 });
    });

    document.addEventListener("updateCart", (e) => {
      const requestId = e.detail.data?.requestId;

      // Debounce - cancel update if another request is already in progress.
      if (requestId === this.requestId || !requestId) {
        this._updateCart(e.detail.cart.sections[this.sectionId]);
      }
    });

    this.addEventListener("change", (e) => {
      const item = e.target.closest("[data-item-key]");
      if (!item) return;

      this._updateQty({
        key: item.dataset.itemKey,
        quantity: parseInt(e.target.value, 10),
      });
    });
  }

  disconnectedCallback() {}

  _updateQty({ key, quantity }) {
    window.changeCart(
      { id: key, quantity },
      {
        onError: () => this._refreshCart(),
        data: { requestId: ++this.requestId },
        sections: [this.sectionId],
      },
    );
  }

  _refreshCart() {
    window
      .fetchPageData({
        path: "/cart",
        options: { sectionId: this.sectionId },
      })
      .then((markup) => this._updateCart(markup));
  }

  _updateCart(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");
    const sourceContent = html.querySelector(".mini-cart__content");
    morph(this, sourceContent);
  }

  get sectionId() {
    return this.getAttribute("section-id");
  }
}

if (!customElements.get("cart-content")) {
  customElements.define("cart-content", CartContent);
}
